import { ReactNode, HTMLAttributes } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    padding?: 'none' | 'sm' | 'md' | 'lg'
}

const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
}

export const Card = ({ children, padding = 'none', className = '', ...props }: CardProps) => (
    <div
        className={`rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900 ${paddingClasses[padding]} ${className}`}
        {...props}
    >
        {children}
    </div>
)

export const CardHeader = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
    <div className={`px-4 py-3 ${className}`}>{children}</div>
)

export const CardContent = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
    <div className={`px-4 py-3 ${className}`}>{children}</div>
)

export const CardFooter = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
    <div className={`flex items-center gap-2 px-4 py-3 ${className}`}>{children}</div>
)
